import React, { Component } from "react";
import { Alert } from "react-bootstrap";
import SelectTopologyDropDown from "./SelectTopologyDropDown";
import { getTopologyName } from "../../UserFunctions";

class KpiSummaryMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            topologyList: [],
            error: "",
        };
    }

    componentDidMount() {
        getTopologyName()
            .then((response) => {
                if (response.status === 200) {
                    this.setState((prevState) => {
                        console.log("prevState", prevState)
                        return {
                            topologyList: response.data.topology_options,
                        };
                    });
                } else {
                    console.log("Execption Occurred");
                }
            })
            .catch((error) => {
                this.setState(() => {
                    return {
                        topologyList: [],
                        error: error.response.data.message,
                    };
                });
            });
    }

    render() {
        return (
            <div data-test="automateKpitjav2SummaryDashboardComponent">
                <div className="page-wrapper">
                    <div className="container-fluid" style={{ marginLeft: "0%" }}>
                        <div
                            className="page-content fade-in-up"
                            style={{ margin: "2% 3%", backgroundColor: "white" }}
                        >
                            {this.state.error ? (
                                <Alert key="danger" variant="danger">
                                    {this.state.error}
                                </Alert>
                            ) : (
                                <SelectTopologyDropDown
                                    {...this.props}
                                    topologyData={this.state.topologyList}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default KpiSummaryMain;
